export default __webpack_public_path__ + "static/media/mid-grows.ff2b0114.png";